import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import PageHeader from '../pageHeader'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const PageLayout = React.forwardRef((props, ref) => {
  const {
    title,
    widthMode,
    crumbs,
    crumbsFullWidth,
    buttons,
    subheader,
    children,
    customHeader: CustomHeader,
    customHeaderProps,
    cls = {},
    titleAllowOverflow,
  } = props

  return (
    <div
      className={cx(
        'container',
        { 'page-width': widthMode === 'page' },
        cls.container
      )}
    >
      <div className={cx('header', cls.header)}>
        {CustomHeader ? (
          <CustomHeader
            title={title}
            crumbs={crumbs}
            buttons={buttons}
            {...customHeaderProps}
          />
        ) : (
          <PageHeader
            title={title}
            crumbs={crumbs}
            crumbsFullWidth={crumbsFullWidth}
            buttons={buttons}
            subheader={subheader}
            titleAllowOverflow={titleAllowOverflow}
          />
        )}
      </div>
      <div
        ref={ref}
        className={cx('content', 'page-layout', cls.content)}
        id='main-content'
      >
        {children}
      </div>
    </div>
  )
})

PageLayout.displayName = 'PageLayout'

PageLayout.propTypes = {
  title: PropTypes.node.isRequired,
  widthMode: PropTypes.oneOf(['full', 'page']),
  crumbs: PropTypes.array,
  crumbsFullWidth: PropTypes.bool,
  buttons: PropTypes.array,
  subheader: PropTypes.any,
  children: PropTypes.node,
  customHeader: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  customHeaderProps: PropTypes.object,
  cls: PropTypes.object,
  titleAllowOverflow: PropTypes.bool,
}

export default PageLayout
